import PropTypes from "prop-types";
import { PropertySelect } from "../../../../../components/PropertySelect/PropertySelect";

const InteractionFactorSelector = ({ factors, onChange }) => {
  /* Recreate factors string based on previous factors array and value that changed */
  const handleChange =
    (index) =>
    ({ value }) => {
      const newFactors = [...factors];
      newFactors[index] = value;
      onChange(newFactors);
    };

  const handleRemove = (index) => {
    const newFactors = [...factors];
    newFactors.splice(index, 1);
    onChange(newFactors);
  };

  return (
    <div className="flex-grow-1 d-flex gap-2 flex-column interaction p-2">
      <span className="informative d-flex align-items-center gap-1">
        <i className="fa-solid fa-link" />
        <span>Interaction</span>
        <div className="flex-grow-1" />
        <span className="font-style-italic discrete-text">
          {factors.length}/5
        </span>
      </span>
      {factors.map((factor, index) => (
        <div key={index} className="d-flex gap-2 align-items-center">
          <PropertySelect
            value={factor}
            className="flex-grow-1"
            onChange={handleChange(index)}
            placeholder="Select factor"
          />
          {index > 0 && (
            <i
              className="fa-solid fa-xmark danger clickable"
              onClick={() => handleRemove(index)}
            />
          )}
        </div>
      ))}
      {factors.length < 5 && (
        <div
          className="add-factor d-flex align-items-center p-1 clickable"
          onClick={() => handleChange(factors.length)({ value: null })}
        >
          <i className="fa-solid fa-plus fa-lg discrete-icon" /> Add factor
        </div>
      )}
    </div>
  );
};

InteractionFactorSelector.propTypes = {
  factors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export const FactorSelector = ({ factor, onChange, onRemove }) => {
  /* In the case of interactions there will be several factors separated by "*" */
  const factors = factor ?? [];
  return (
    <div className="factor-selector d-flex align-items-center gap-1">
      {factors.length > 1 ? (
        <InteractionFactorSelector factors={factors} onChange={onChange} />
      ) : (
        <>
          <PropertySelect
            autoFocus
            value={factors[0]}
            className="flex-grow-1"
            onChange={({ value }) => onChange([value])}
            placeholder="Select factor"
          />
          {/* If there is a factor, add the possibility to create interaction */}
          {factors[0] && (
            <i
              className="fa-solid fa-link clickable discrete-icon"
              data-tooltip-id="tooltip"
              data-tooltip-content="Create interaction"
              data-tooltip-place="right"
              data-tooltip-variant="dark"
              // Add * at the end to create a 2nd null factor within interaction
              onClick={() => onChange([...factors, null])}
            />
          )}
        </>
      )}
      <i className="fa-solid fa-trash danger clickable" onClick={onRemove} />
    </div>
  );
};

FactorSelector.propTypes = {
  factor: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
